import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'

import Hub from 'base/hub'
import Event from 'base/event'
import Button from '@everlane/button'
import Facebook from 'base/lib/singletons/facebook'
import ImageHelper from 'base/lib/image_helper'
import { updateVisitor } from 'base/actions/synchronous'

const LOADING_TEXT = 'Connecting…'
const FACEBOOK_ICON_URL = 'i/072c2eb3_33d0.png'

class FacebookConnectButton extends Component {
  static propTypes = {
    buttonText: PropTypes.string,
    onClick: PropTypes.func,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    className: PropTypes.string,
    fullWidth: PropTypes.bool,
    siteLocation: PropTypes.string,
    disabled: PropTypes.bool,
    showIcon: PropTypes.bool,
  }

  static defaultProps = {
    buttonText: 'Facebook',
    showIcon: false,
  }

  state = {
    isLoading: false,
  }

  connect = () => {
    const { onClick, siteLocation, onSuccess, onError } = this.props
    this.setState({ isLoading: true })

    !!onClick && onClick()

    Hub.pub(Event.Login.FACEBOOK_BUTTON)

    Facebook.login({ siteLocation })
      .then(response => {
        this.setState({ isLoading: false })
        Hub.pub(Event.User.SIGN_IN, {
          siteLocation,
        })
        this.props.updateVisitor(response.session.visitor)
        !!onSuccess && onSuccess({ isNewUser: !!response.session.user.just_created })
      })
      .fail(errorMessage => {
        this.setState({ isLoading: false })
        !!onError && onError(errorMessage)
      })
  }

  renderIcon = () => {
    const { buttonText } = this.props
    return (
      <div>
        <img
          src={ImageHelper.imageUrl(FACEBOOK_ICON_URL)}
          alt="Log in with Facebook"
          className="facebook-connect-button__cta-icon"
        />
        <span className="facebook-connect-button__cta-text">{buttonText}</span>
      </div>
    )
  }

  renderFlatButtonContent = () => {
    if (this.state.isLoading) {
      return LOADING_TEXT
    } else if (this.props.showIcon) {
      return this.renderIcon()
    } else {
      return this.props.buttonText
    }
  }

  render() {
    const { disabled } = this.props
    const className = classNames(this.props.className, {
      'facebook-connect-button__button--icon': this.props.showIcon,
    })

    return (
      <Button disabled={disabled} onClick={this.connect} className={className}>
        {this.renderFlatButtonContent()}
      </Button>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateVisitor: visitor => dispatch(updateVisitor(visitor)),
  }
}

export default connect(null, mapDispatchToProps)(FacebookConnectButton)
